import React from 'react';
import { Redirect } from 'react-router-dom';
import { v4 as uuid } from 'uuid';

import Button from '../components/Button';
import '../styles/login.css';

import { connect } from 'react-redux';
import { setAuthedUser } from '../actions/authedUser'

class UnwrappedLogin extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loggedIn: false,
      userName: '',
      userId: uuid()
    }

    // this.handleSubmit = this.login.bind(this)
  }

  login = (e) => {
    e.preventDefault();
    
    this.props.loginAction({
      name: this.state.userName,
      id: this.state.userId
    });
    this.setState({ loggedIn: true });
  }

  onChange = (e) => {
    this.setState({ userName: e.target.value });
  }

  render() {
    return (
      <>
        <div className="header">
          <div className="decoration" />
          <h1>Tactorius</h1>
          <div className="decoration" />
        </div>
        <div className="panel">
          <h2>Login</h2>
          <form onSubmit={this.login}>
            <label>
              Username:
              <br />
              <input type="text" onChange={this.onChange} />
            </label>
            {/* <br /> */}
            {/* <label>
              Password:
              <br />
              <input type="text" />
            </label> */}
            <br /><br />
            <div className='login-buttons'>
              <Button type="submit" isDisabled={!this.state.userName} text='Login' />
              {/* <Button text='Register' /> */}
            </div>
          </form>
          <br />
          {/* <a>Forgot password?</a> */}
          {this.state.loggedIn &&
            <Redirect to={'/home'} />
          }
        </div>
      </>
    )
  }
}

function mapStateToProps ({ authedUser }) {
  return {
    authedUser
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loginAction: (userInfo) => {
      dispatch(setAuthedUser(userInfo)) 
    }
  }
}

export const Login = connect(mapStateToProps, mapDispatchToProps)(UnwrappedLogin);